export default [
  {
    path: '/dashboard/main',
    name: 'dashboard-main',
    component: () => import('@/views/dashboard/main/Dashboard.vue'),
    meta: {
      pageTitle: 'Dashboard Geral',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
  },
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
  },
]
